import { client } from '../sanity'
import type { CategoryType } from '@/types/categoryType'

/**
 * Fetch all categories (excluding drafts)
 */
export const getAllCategories = async (): Promise<CategoryType[]> => {
  return client.fetch(
    `*[_type == "category" && !(_id match "draft.*")] | order(name asc) {
      _id,
      _type,
      name,
      code,
      _createdAt,
      _updatedAt
    }`
  )
}
